module.exports = __webpack_public_path__ + "static/img/yellow_line.03801270.png";